import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import toast from "react-hot-toast";
import icons from "../../../assets/images/constantIcons";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";
import { MdOutlineCalendarMonth } from "react-icons/md";
import CategoryPopup from "./CategoryPopup";
import PlayersPopup from "./PlayerPopUp";
import { TimePicker } from 'antd';
import dayjs from "dayjs";

const EditExpenseForm = ({ isOpen, onClose, entryType, fetchExpenses, expenseId }) => {
  const [parties, setParties] = useState([]);
  const [category, setCategory] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isPlayerDropdownOpen, setIsPlayerDropdownOpen] = useState(false);
  const [isCategoryPopupOpen, setIsCategoryPopupOpen] = useState(false);
  const [isPlayersPopupOpen, setIsPlayersPopupOpen] = useState(false);
  const [expense, setExpense] = useState([]);
  const [existingFiles, setExistingFiles] = useState([]);

  const FetchExpensebyId = async () => {
    try {
      const response = await apiService.get(`/expenses/${expenseId}`);
      setExpense(response.data);
      setExistingFiles(response.data.files || []);
    } catch (errors) {
      handleError(errors);
    }
  };

  useEffect(() => {
    FetchExpensebyId()
  }, [])

  const parseDate = (dateStr) => {
    if (!dateStr) return new Date();
    const parsed = new Date(dateStr);
    return isNaN(parsed) ? new Date() : parsed;
  };
  const parseTime = (timeStr) => {
    if (!timeStr) return dayjs();
    const parsed = dayjs(timeStr);
    return parsed.isValid() ? parsed : dayjs();
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      date: expense?.date ? parseDate(expense.date) : new Date(),
      time: expense?.time ? parseTime(expense.time) : dayjs(),
      amount: expense?.amount || "",
      playerName: expense?.party?.name || "",
      // category: expense?.expense_category?.name || "",
      remarks: expense?.details || "",
      paymentMode: expense?.payment_mode ? expense?.payment_mode.charAt(0).toUpperCase() + expense?.payment_mode.slice(1) : "Cash",
      files: [],
    },
    validationSchema: Yup.object({
      date: Yup.date()
        .required("Date is required"),
      time: Yup.mixed().required("Time is required"),
      amount: Yup.string()
        .required("Amount is required")
        .matches(/^\d+(\.\d{1,2})?$/, "Amount must be a valid number"),
      // category: Yup.string().required("Category is required"),
      playerName: Yup.string().required("Party is required"),
    }),
    onSubmit: async (values) => {
      console.log("values", values);

      try {
        const getCategoryIdByName = (name) => {
          const cat = category.find((c) => c.name === name);
          return cat ? cat.id : null;
        };

        const getPartyIdByName = (name) => {
          const party = parties.find((p) => p.name === name);
          return party ? party.id : null;
        };

        const payload = {
          expense: {
            date: values.date.toISOString().split("T")[0],
            time: values.time ? values.time.format("HH:mm") : null,
            amount: parseFloat(values.amount),
            details: values.remarks,
            entry_type: entryType,
            payment_mode: values.paymentMode.toLowerCase(),
            // expense_category_id: getCategoryIdByName(values.category),
            party_id: getPartyIdByName(values.playerName),
          
          }
        };

        if (values.files && values.files.length > 0) {
          payload.expense.files = Array.from(values.files).map((file) => ({
            name: file.name,
            type: file.type,
            size: file.size,
          }));
        } else if (existingFiles.length > 0) {
          // Send existing files info so backend keeps them
          payload.expense.files = existingFiles;
        }
        await apiService.patch(`/expenses/${expenseId}`, payload);
        onClose();
        toast.success("Entry Updated successfully!", { duration: 2000 });
        fetchExpenses();
      } catch (errors) {
        handleError(errors);
      }
    },
  });


  const handleTimer = (e, setFieldValue) => {
    setFieldValue("time", e);
  };
  const fetchParties = async () => {
    try {
      const response = await apiService.get("/parties");
      setParties(response.data);
    } catch (errors) {
      handleError(errors);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await apiService.get("/expense_categories");
      setCategory(response.data);
    } catch (errors) {
      handleError(errors);
    }
  };

  useEffect(() => {
    fetchParties();
    fetchCategories();
  }, []);

  return (
    isOpen && (
      <>
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-4 s:p-6 w-[310px] s:w-[350px] md:w-[460px] relative">
            <div className="flex justify-between items-center mb-4">
              <h2 className={`text-lg font-semibold text-G800 `}>
                Edit Entry
              </h2>
              <div
                className="absolute top-7 right-3 bg-green50 rounded-full p-2 cursor-pointer w-[32px] h-[32px] flex justify-center items-center"
                onClick={() => {
                  formik.resetForm();
                  onClose();
                }}
              >
                <icons.IoClose className=" text-green700 text-xl" />
              </div>
            </div>

            <form onSubmit={formik.handleSubmit} className="space-y-4 max-h-[70vh] overflow-y-auto vertical text-start">
              <div className="flex gap-4">
                <div className="flex-1">
                  <label className="block text-sm text-gray-600 mb-1">
                    Date <span className="text-red ">*</span>
                  </label>
                  <div className="relative">
                    <DatePicker
                      selected={formik.values.date}
                      onChange={(date) => formik.setFieldValue("date", date)}
                      dateFormat="dd MMM, yyyy"
                      className="inputtext w-full pr-10"
                    />
                    <MdOutlineCalendarMonth className="absolute right-3 top-2.5 text-blueButton pointer-events-none" />
                  </div>
                </div>
                <div className="flex-1">
                  <label className="block text-sm text-gray-600 mb-1">
                    Time <span className="text-red ">*</span>
                  </label>
                  <div className="w-full">
                    <TimePicker
                      value={formik.values.time}
                      format="hh:mm A"
                      use12Hours
                      allowClear={false}
                      inputReadOnly={true}
                      showNow={true}
                      popupClassName="custom-timepicker-popupok"
                      getPopupContainer={() => document.body}
                      onSelect={(time) => {
                        if (time) {
                          formik.setFieldValue("time", time);
                        }
                      }}
                      onBlur={() => formik.setFieldTouched("time", true)}
                      className="inputtext w-full focus:outline-none outline-none"
                    />

                  </div>
                  {formik.touched.time && formik.errors.time && (
                    <p className="text-red text-sm">{formik.errors.time}</p>
                  )}
                </div>
              </div>

              <div>
                <label className="block text-sm text-gray-600 mb-1">
                  Amount <span className="text-red">*</span>
                </label>
                <input
                  type="text"
                  name="amount"
                  className="inputtext w-full"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={Math.trunc(formik.values.amount)}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9.]/g, "");
                  }}
                  placeholder="200 or 400"
                />

                {formik.touched.amount && formik.errors.amount && (
                  <p className="text-red text-sm">{formik.errors.amount}</p>
                )}
              </div>

              <div className="flex-1 relative">
                <label className="block text-sm text-gray-600 mb-1">
                  Party Name <span className="text-red">*</span>
                </label>
                <button
                  type="button"
                  onClick={() => setIsPlayerDropdownOpen(!isPlayerDropdownOpen)}
                  className="inputtext w-full text-left"
                >
                  {formik.values.playerName || "Select party"}
                </button>

                {isPlayerDropdownOpen && (
                  <div className="absolute mt-1 z-20 w-full bg-white shadow border rounded max-h-60 overflow-y-auto">
                    {parties?.length === 0 ? (
                      <div className="px-4 py-2 text-gray-500">
                        No Party found
                      </div>
                    ) : (
                      parties?.map((par) => (
                        <button
                          key={par.id}
                          onClick={() => {
                            formik.setFieldValue("playerName", par.name);
                            setIsPlayerDropdownOpen(false);
                          }}
                          className="w-full text-left px-4 py-2 hover:bg-gray-50"
                        >
                          {par.name}
                        </button>
                      ))
                    )}
                    <button
                      onClick={() => {
                        setIsPlayersPopupOpen(true);
                        setIsPlayerDropdownOpen(false);
                      }}
                      className="w-full text-left px-4 py-2 bg-G30 hover:bg-gray-50 text-blue-600 font-medium border-t"
                    >
                      + Add New Party
                    </button>
                  </div>
                )}
              </div>

              <div>
                <label className="block text-sm text-gray-600 mb-1">
                  Description 
                </label>
                <input
                  type="text"
                  name="remarks"
                  className="inputtext w-full"
                  onChange={formik.handleChange}
                  value={formik.values.remarks}
                  placeholder="Enter details(Bills No,Name,Quantity)"
                />
              </div>

               

                <div className="">
                  <label className="block text-sm text-gray-600 mb-1">
                    Payment Mode <span className="text-red ">*</span>
                  </label>
                  <select
                    name="paymentMode"
                    className="inputtext w-full"
                    onChange={formik.handleChange}
                    value={formik.values.paymentMode}
                  >
                    <option value="Cash">Cash</option>
                  </select>
              </div>

              <div className="flex justify-end gap-4 pt-4">
                <button
                  type="button"
                  onClick={onClose}
                  className="w-[75px] sm:w-[93px] text-sm py-2 text-center border border-green text-green rounded-lg"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="w-[75px] sm:w-[93px] text-sm py-2 text-center  bg-green text-white rounded-lg"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>

        <CategoryPopup
          isOpen={isCategoryPopupOpen}
          onClose={() => setIsCategoryPopupOpen(false)}
          onCategorySuccess={fetchCategories}
          customerId={123}
        />
        <PlayersPopup
          isOpen={isPlayersPopupOpen}
          onClose={() => setIsPlayersPopupOpen(false)}
          onPlayerSuccess={fetchParties}
          customerId={123}
        />
      </>
    )
  );
};

export default EditExpenseForm;
